/**
 * GraphQL query information builder for IA Corners.
 * Constructs the query parameters needed to fetch IA Corner data from the GraphQL API,
 * including device information, carrier, language, plan, and the IA Corner identifier.
 */

import DeviceConfig from '@devices/config';
import FlavourConfig from '@shared/config/flavours';
import Languages from '@shared/types/enums/languages';
import TranslationManager from '@shared/assets/locale/translationsManager';
import { IACornersQueryInfo } from '@shared/types/interfaces/query';
import { store } from '@shared/store/store';

/******************/
/**     INFO     **/
/******************/

/**
 * Builds query information object for IA Corner GraphQL requests.
 * Extracts device, carrier, language, and plan information from the store
 * and user configuration to construct the query parameters.
 *
 * @param {string} id - IA corner identifier to fetch
 * @returns {IACornersQueryInfo} IA corners query information including device, carrier, language, plan and IA corner identifier
 */
export default function info(id: string): IACornersQueryInfo {
  const { plans, user } = store.getState();
  const device = DeviceConfig.info.os.toUpperCase();
  let carrier = user.carrierId || FlavourConfig.carrierId || '';
  let language = TranslationManager.currentLanguage;
  let plan = user.planId || '';

  if (language === Languages.ORIGINAL || !language) {
    language = Languages.SPANISH;
  }

  if (user.isAnonymous) {
    carrier = FlavourConfig.carrierId;
    plan = plans.anonymous?.id || plan;
  }
  return {
    query: {
      carrier,
      device,
      iacorner: id,
      language: TranslationManager.currentLanguage,
      plan,
    },
  };
}
